<template>
  <div id="app">
    <router-view />
    <div v-if="pageInfo.showPatientQrCode" id="appQrcode" class=" fixed bottom-[100px] right-[24px] cursor-pointer min-w-[100px] min-h-[100px] rounded-lg shadow-[0_0_20px_0_rgba(0,0,0,.2)]">
      <i class="el-icon-circle-close text-[16px] text-gray-400 absolute -top-4 -right-4" @click="pageInfo.showPatientQrCode = false"></i>
      <img
        class="w-[100px] h-[100px] hover:w-[200px] hover:h-[200px]"
        src="@/assets/images/huixitang_qrcode.png"
        mode="scaleToFill"
      />
    </div>
    
    <!-- 用户须知弹窗 -->
    <div v-if="showUserNoticeDialog" class="user-notice-overlay">
      <div class="user-notice-dialog" :style="{ 
        backgroundImage: `url(${userNoticeBgImage})`,
        backgroundSize: '100% 100%',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }" @click.stop>
        <!-- <div class="user-notice-header">
          <h2 class="user-notice-title">用户须知</h2>
          <p class="user-notice-subtitle">USER NOTICE</p>
        </div> -->
        <div class="user-notice-content">
          <!-- <h2 class="user-notice-title">用户须知</h2> -->
          <p v-if="agreementList.length > 0">
            请您仔细阅读并同意
            <span 
              v-for="(agreement, index) in agreementList" 
              :key="agreement.agreementType || index"
            >
              《{{ agreement.title }}》
            </span>
            ，此次操作不会对您的使用产生任何影响，同意后即可正常使用系统，感谢您的配合。
          </p>
          <p v-else>
            请您仔细阅读并同意相关协议，此次操作不会对您的使用产生任何影响，同意后即可正常使用系统，感谢您的配合。
          </p>
          <p v-if="agreementList.length > 0">
            点击按钮即代表您已阅读并同意
            <span 
              v-for="(agreement, index) in agreementList" 
              :key="agreement.agreementType || index"
              class="document-link"
              @click="openAgreementDetail(agreement)"
            >
              《{{ agreement.title }}》
            </span>
          </p>
          <p v-else>
            点击按钮即代表您已阅读并同意相关协议
          </p>
        </div>
        <div class="user-notice-footer">
          <button class="user-notice-btn" @click="closeUserNoticeDialog">同意协议</button>
        </div>
      </div>
    </div>

    <!-- 知情同意书弹窗 -->
    <div v-if="showConsentDialog" class="consent-dialog-overlay">
      <div class="consent-dialog-container">
        <div class="consent-dialog" @click.stop>
          <!-- 动态显示协议内容 -->
           <!-- 默认内容（当没有协议内容时） -->
          <div v-if="currentAgreement && currentAgreement.content" v-html="currentAgreement.content"></div>
          
          <div v-else>
            <div class="consent-header">
              <h2 class="consent-title">协议详情</h2>
            </div>
            <div class="consent-content">
              <div class="consent-text">
                <p>暂无协议内容</p>
              </div>
            </div>
          </div>

          
        </div>
        <div class="consent-footer">
          <button class="consent-btn" @click.stop="backToUserNotice">返回</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { loginInfoPost } from "@/service/user/index";
import { getAgreementList, agreeAgreements } from "@/service/agreement/index";

export default {
  data() {
    return {
      isAndroid: /android/i.test(navigator.userAgent),
      show: true,
      showUserNoticeDialog: false, // 控制用户须知弹窗显示
      showConsentDialog: false, // 控制知情同意书弹窗显示
      userNoticeBgImage: require('@/assets/images/xybj.png'),
      agreementList: [], // 协议列表
      currentAgreement: null // 当前选中的协议
    }
  },
  computed: {
    ...mapGetters(["pageInfo"]),
  },
  beforeCreate() {
    // const UA = window.navigator.userAgent.toLowerCase();
    
    // const isAndroid = (UA && UA.indexOf('android') > 0);
    // const isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA));

    // console.log(isAndroid,isIOS);
    // console.log(window.location.href)
    // if(isAndroid || isIOS) {
    //   console.log('动端环境')
    //   const url = window.location.href;
    //   if(url.search('https://pad.huiyishanji.com') == -1) {
    //     window.location.href =  'https://pad.huiyishanji.com';
    //   }
    // }else {
    //   console.log('PC')
    // }
  },
  created() {
    const path = this.$route.path || "";
    const name = this.$route.name || "";

    // 如果是访问 transfer 相关的路由，就不要 restoreUserState
    if (path.startsWith("/transfer") || name === "transfer") {
      console.log("跳过 restoreUserState，交给 transfer.vue 自己登录");
    } else {
      // 对于其他页面，包括从transfer跳转过来的页面，都需要恢复状态
      this.restoreUserState();
    }
    
    // 将弹窗控制方法暴露到全局，供其他组件调用
    window.showUserNoticeDialog = this.openUserNoticeDialog;
    window.showConsentDialog = this.openConsentDialog;
  },

  methods: {
    /**
     * 跳转到登录页面，根据customerAccountType添加参数
     */
    goToLogin() {
      const userInfo = JSON.parse(sessionStorage.getItem('userInfo') || '{}');
      const customerAccountType = userInfo.customerAccountType;
      
      if (customerAccountType == 11) {
        this.$router.replace('/login?huaxinkouqiang');
      } else {
        this.$router.replace('/login');
      }
    },
    
    
    /**
     * 恢复用户状态
     */
    restoreUserState() {
      // 延迟执行，确保Vuex持久化插件完成状态恢复
      if (!this.isAndroid) {
        setTimeout(() => {
          this.attemptRestoreUserState();
        }, 100);
      }
    },
    
    /**
     * 尝试恢复用户状态
     */
    attemptRestoreUserState() {
      // 从 sessionStorage 获取用户信息
      const userInfo = JSON.parse(sessionStorage.getItem('userInfo') || '{}');
      const mobilePhone = sessionStorage.getItem('userMobilePhone') || userInfo.mobilePhone || userInfo.phone || userInfo.userName;
      
      // 检查Vuex中是否已经有用户信息
      const vuexUserInfo = this.$store.state.user.userInfo;
      
      // 优先使用Vuex中的数据，如果没有则使用sessionStorage中的数据
      const finalUserInfo = (vuexUserInfo && vuexUserInfo.token) ? vuexUserInfo : userInfo;
      const finalMobilePhone = mobilePhone || finalUserInfo.mobilePhone || finalUserInfo.phone;
      
      // 增加token有效性检查 - 只要有有效的token就允许通过
      if (finalUserInfo.token && finalUserInfo.token.length > 10) {
        // 恢复Vuex状态
        this.$store.commit("user/setUserInfo", finalUserInfo);
        this.$store.commit("user/setIsLogin", true);
        this.$store.commit("user/setCustomerTyeCodeName", finalUserInfo?.customerTypeCode ?? 0);
        this.$store.commit("user/setIsNonMedical", 
          finalUserInfo?.customerAccountType == 2 ||
          finalUserInfo?.customerAccountType == 5 ||
          finalUserInfo?.customerAccountType == 6 ||
          finalUserInfo?.customerAccountType == 7 ||
          finalUserInfo?.customerAccountType == 12 ||
          finalUserInfo?.doctorAccountType == 2 ||
          finalUserInfo?.doctorAccountType == 5 ||
          finalUserInfo?.doctorAccountType == 6 ||
          finalUserInfo?.doctorAccountType == 7 ||
          finalUserInfo?.doctorAccountType == 12
        );
        this.$store.commit("user/setAuthoritys", finalUserInfo?.authoritys ?? {});
        
        // 恢复成功后，调用更新接口
        this.checkAndUpdateCode();
      } else {
        // 尝试从localStorage恢复
        const localUserInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
        
        if (localUserInfo.token && localUserInfo.token.length > 10) {
          this.$store.commit("user/setUserInfo", localUserInfo);
          this.$store.commit("user/setIsLogin", true);
          this.checkAndUpdateCode();
          return;
        }
        
        // transfer、clinic、demonstrate 页面不要跳到登录
        if (!this.$route.path.startsWith('/transfer') && 
            this.$route.path !== '/login' && 
            this.$route.path !== '/clinic' && 
            this.$route.path !== '/demonstrate') {
          this.goToLogin();
        }
      }
    },
    
    async checkAndUpdateCode() {
      try {
        // 优先从localStorage获取手机号，如果没有再从sessionStorage获取
        let mobilePhone = sessionStorage.getItem('userMobilePhone');
        
        if (!mobilePhone) {
          const userInfo = JSON.parse(sessionStorage.getItem('userInfo') || '{}');
          mobilePhone = userInfo.mobilePhone || userInfo.phone;
        }
        
        if (mobilePhone) {
          // 调用后台提供的更新接口，传递手机号
          const response = await loginInfoPost({
            phone: mobilePhone
          });
          
          if (response.code === 200) {
            // 接口调用成功后，主动获取最新的用户信息并更新前端状态
           await this.syncUserPermissions(mobilePhone);
          }
        } else {
          // 不跳转到登录页面，因为用户可能已经通过其他方式登录
        }
      } catch (error) {
        console.error('代码更新检查失败:', error);
      }
    },
    
    /**
     * 同步用户权限信息
     * @param {string} mobilePhone - 手机号
     */
    async syncUserPermissions(mobilePhone) {
      try {
        // 直接调用loginInfoPost接口获取最新用户信息
        const response = await loginInfoPost({
          phone: mobilePhone
        });
        
        let newUserInfo = null;
        if (response.code === 200 && response.data) {
          newUserInfo = response.data;
        } else {
          // 如果接口返回异常，强制刷新页面
          // window.location.reload();
          return;
        }
        
        // 获取原有的用户信息（包含token和authoritys等）
        const originalUserInfo = JSON.parse(sessionStorage.getItem('userInfo') || '{}');
        
        // 合并用户信息：先使用新数据，但保留原有数据中的关键字段
        const mergedUserInfo = { ...originalUserInfo, ...newUserInfo };
        
        // 如果新数据没有token，强制保留原有的token
        if (!newUserInfo.token && originalUserInfo.token) {
          mergedUserInfo.token = originalUserInfo.token;
        }
        
        // 如果新数据中没有authoritys字段，保留原有的authoritys
        if (!('authoritys' in newUserInfo) && originalUserInfo.authoritys) {
          mergedUserInfo.authoritys = originalUserInfo.authoritys;
        }
        
        // 确保 mergedUserInfo 包含所有必要的字段
        // 如果 newUserInfo 中有 authoritys（即使是空对象），也使用新数据
        // 只有当 newUserInfo 完全没有 authoritys 字段时，才保留原有的
        
        // 更新Vuex store中的用户信息
        this.$store.commit("user/setUserInfo", mergedUserInfo);
        this.$store.commit("user/setCustomerTyeCodeName", mergedUserInfo?.customerTypeCode ?? 0);
        this.$store.commit("user/setIsNonMedical", 
          mergedUserInfo?.customerAccountType == 2 ||
          mergedUserInfo?.customerAccountType == 5 ||
          mergedUserInfo?.customerAccountType == 6 ||
          mergedUserInfo?.customerAccountType == 7 ||
          mergedUserInfo?.customerAccountType == 12 ||
          mergedUserInfo?.doctorAccountType == 2 ||
          mergedUserInfo?.doctorAccountType == 5 ||
          mergedUserInfo?.doctorAccountType == 6 ||
          mergedUserInfo?.doctorAccountType == 7 ||
          mergedUserInfo?.doctorAccountType == 12
        );
        // 更新权限信息
        this.$store.commit("user/setAuthoritys", mergedUserInfo?.authoritys ?? {});
        // 更新登录状态
        this.$store.commit("user/setIsLogin", true);
        
        // 更新sessionStorage中的用户信息（确保包含所有字段）
        sessionStorage.setItem("userInfo", JSON.stringify(mergedUserInfo));
        
        // 由于 Vuex 使用了 persistedstate，也需要确保 Vuex state 中的 userInfo 是最新的
        // 但 persistedstate 会自动同步，所以这里主要是确保 sessionStorage 中的 userInfo 是最新的
        
        // 更新localStorage中的手机号
        if (newUserInfo.phone) {
          localStorage.setItem("userMobilePhone", newUserInfo.phone);
        }
        
        // 强制刷新页面来应用新权限
        setTimeout(() => {
          // window.location.reload();
        }, 1000);
        
      } catch (error) {
        console.error('同步用户权限信息失败:', error);
        // 如果同步失败，也强制刷新页面
        setTimeout(() => {
          // window.location.reload();
        }, 1000);
      }
    },
    
    /**
     * 显示用户须知弹窗
     * @param {Array} agreementList - 协议列表数据
     */
    openUserNoticeDialog(agreementList = null) {
      // 如果传入了协议数据，则使用传入的数据
      if (agreementList && Array.isArray(agreementList)) {
        this.agreementList = agreementList;
        console.log('使用传入的协议数据:', this.agreementList);
      }
      this.showUserNoticeDialog = true;
    },
    
    
    /**
     * 关闭用户须知弹窗（提交协议同意）
     */
    async closeUserNoticeDialog() {
      try {
        // 调用同意协议接口
        await this.submitAgreementConsent();
        
        // 显示成功提示
        this.$message.success('已同意协议');
        
        // 关闭弹窗
        this.showUserNoticeDialog = false;
      } catch (error) {
        console.error('提交协议同意失败:', error);
        // 显示错误提示
        this.$message.error('协议同意提交失败，请重试');
        // 即使接口调用失败，也关闭弹窗
        this.showUserNoticeDialog = false;
      }
    },
    
    /**
     * 显示知情同意书弹窗
     */
    openConsentDialog() {
      console.log('打开知情同意书弹窗，showConsentDialog:', this.showConsentDialog);
      this.showConsentDialog = true;
      console.log('设置后 showConsentDialog:', this.showConsentDialog);
    },
    
    /**
     * 关闭知情同意书弹窗
     */
    closeConsentDialog() {
      this.showConsentDialog = false;
    },
    
    /**
     * 返回到用户须知弹窗
     */
    backToUserNotice() {
      console.log('backToUserNotice 被调用');
      console.log('当前 showUserNoticeDialog 状态:', this.showUserNoticeDialog);
      
      // 关闭协议详情弹窗
      this.showConsentDialog = false;
      this.showUserNoticeDialog = true;
      
      console.log('设置后 showUserNoticeDialog 状态:', this.showUserNoticeDialog);
      // 用户须知弹窗保持显示状态，不强制关闭
    },
    
    /**
     * 获取协议列表
     */
    async fetchAgreementList() {
      try {
        // 检查用户是否已登录
        const userInfo = this.$store.state.user.userInfo;
        if (!userInfo || !userInfo.token) {
          console.log('用户未登录，跳过获取协议列表');
          this.showUserNoticeDialog = false;
          return;
        }

        const params = {
          channel: 'consultation', // 问诊系统
          customerPhone: userInfo?.mobilePhone || userInfo?.phone,
          dataSource: 'web'
        };
        
        const response = await getAgreementList(params);
        
        if (response.code === 200) {
          this.agreementList = response.data || [];
          console.log('协议列表:', this.agreementList);
          // 打印第一个协议对象的字段，用于调试
          if (this.agreementList.length > 0) {
            console.log('第一个协议对象字段:', Object.keys(this.agreementList[0]));
            // 如果有协议数据，显示用户须知弹窗
            this.showUserNoticeDialog = true;
          } else {
            // 如果没有协议数据，不显示用户须知弹窗
            this.showUserNoticeDialog = false;
            console.log('没有协议数据，不显示用户须知弹窗');
          }
        } else if (response.code === 401) {
          console.log('用户未授权，不显示用户须知弹窗');
          this.showUserNoticeDialog = false;
        } else {
          console.error('获取协议列表失败:', response.msg);
          // 接口调用失败，不显示用户须知弹窗
          this.showUserNoticeDialog = false;
        }
      } catch (error) {
        console.error('获取协议列表异常:', error);
        // 异常情况下不显示用户须知弹窗
        this.showUserNoticeDialog = false;
      }
    },
    
    /**
     * 提交协议同意
     */
    async submitAgreementConsent() {
      try {
        // 构建协议ID数组
        const agreements = this.agreementList.map(agreement => ({
          agreementId: agreement.agreementId || agreement.id, // 尝试不同的ID字段名
          contentHtml: agreement.content
        }));
        
        const params = {
          agreements: agreements,
          channel: 'consultation', // 问诊系统
          customerPhone: this.$store.state.user.userInfo?.mobilePhone || this.$store.state.user.userInfo?.phone,
          dataSource: 'web'
        };
        
        console.log('提交协议同意参数:', params);
        
        const response = await agreeAgreements(params);
        
        if (response.code === 200) {
          console.log('协议同意提交成功:', response);
        } else {
          console.error('协议同意提交失败:', response.msg);
          throw new Error(response.msg || '协议同意提交失败');
        }
      } catch (error) {
        console.error('提交协议同意异常:', error);
        throw error;
      }
    },
    
    /**
     * 打开协议详情
     * @param {Object} agreement - 协议对象
     */
    openAgreementDetail(agreement) {
      console.log('打开协议详情:', agreement);
      console.log('当前 showConsentDialog 状态:', this.showConsentDialog);
      
      // 只隐藏用户须知弹窗，不提交协议同意
      this.showUserNoticeDialog = false;
      
      // 设置当前选中的协议
      this.currentAgreement = agreement;
      console.log('设置 currentAgreement:', this.currentAgreement);
      
      // 延迟一点时间确保用户须知弹窗完全关闭
      setTimeout(() => {
        console.log('延迟后设置 showConsentDialog 为 true');
        this.showConsentDialog = true;
        console.log('设置后 showConsentDialog:', this.showConsentDialog);
      }, 100);
    }
  },
  // const UA = window.navigator.userAgent.toLowerCase();
    
    // const isAndroid = (UA && UA.indexOf('android') > 0);
    // const isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA));

    // console.log(isAndroid,isIOS);
    // console.log(window.location.href)
    // if(isAndroid || isIOS) {
    //   console.log('动端环境')
    //   const url = window.location.href;
    //   if(url.search('https://pad.huiyishanji.com') == -1) {
    //     window.location.href =  'https://pad.huiyishanji.com';
    //   }
    // }else {
    //   console.log('PC')
    // }
}
</script>

<style>
.strong {
  font-weight: 600;
}
* {
  margin: 0;
  padding: 0;
  /* scrollbar-width: none; */
  /* -ms-overflow-style: none; */
}
*::-webkit-scrollbar {
  width: 0px; 
    height: 0px;
    background-color: #eee;
} 
#app {
  width: 100%;
  height: 100%;
}

html,
body {
  width: 100%;
  height: 100%;
}
.el-message {
  top: 100px !important;
}
.confirmbtn {
  color: #ffffff;
  background-color: #13bfba !important;
  border-color: #13bfba !important;
}
.cancelbtn:hover {
  color: #13bfba !important;
  background-color: #fff !important;
  border-color: #13bfba !important;
}
.video-js .vjs-big-play-button {
  transform: scale(0.8);
}
.el-input.is-active .el-input__inner, .el-input__inner:focus {
  border-color: #13bfba !important;
}
.el-loading-spinner {
  left: 50% !important;
  margin-left: -25px;
}
</style>

<style lang="less">
.confirmBtn {
  background: #19b2ad !important;
  border-color: #19b2ad !important;
  &:hover {
    background: #19b2ad !important;
    border-color: #19b2ad !important;
  }
}
.cancelBtn {
  &:hover {
    color: #19b2ad !important;
    border-color: #19b2ad !important;
  }
}

/* 用户须知弹窗样式 */
.user-notice-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
}

.user-notice-dialog {
  width: 516px;
  max-width: 90vw;
  // background: #ffffff;
  // border: none;
  // border-radius: 16px;
  // box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2);
  // overflow: hidden;
  // position: relative;
  min-height: 418px;
}

.user-notice-dialog::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.02);
  pointer-events: none;
  z-index: 1;
}

.user-notice-header {
  text-align: center;
  padding: 40px 40px 30px;
  position: relative;
  background: rgba(255, 255, 255, 0.1);
  z-index: 2;
}

.user-notice-title {
  font-size: 24px;
  font-weight: 600;
  color: #19b2ad;
  margin: 0 0 20px 0;
  position: relative;
  text-align: center;
}

.user-notice-title::before,
.user-notice-title::after {
  content: '';
  position: absolute;
  top: 50%;
  width: 40px;
  height: 1px;
  background: linear-gradient(90deg, transparent, #e0e0e0, transparent);
}

.user-notice-title::before {
  left: -60px;
}

.user-notice-title::after {
  right: -60px;
}

.user-notice-subtitle {
  font-size: 14px;
  color: #999;
  margin: 0;
  font-weight: 400;
  letter-spacing: 1px;
}

.user-notice-content {
  // padding: 0 40px 30px;
  text-align: center;
  // background: rgba(255, 255, 255, 0.1);
  position: relative;
  z-index: 2;
  margin-top: 66px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height:250px;
}

.user-notice-content p {
  font-size: 14px;
  line-height: 1.6;
  color: #333;
  margin: 0 0 16px 0;
  text-align: left;
  max-width: 450px;
}

.user-notice-content p:last-child {
  margin-bottom: 0;
  font-size: 12px;
  margin-top:30px;
}

.document-link {
  color: #19b2ad;
  font-weight: 500;
  cursor: pointer;
  text-decoration: none;
  transition: color 0.3s ease;
}

.document-link:hover {
  color: #13bfba;
  text-decoration: underline;
}

.user-notice-footer {
  padding: 20px 40px 40px;
  text-align: center;
  background: rgba(255, 255, 255, 0.1);
  position: relative;
  z-index: 2;
}

.user-notice-btn {
  background: #19b2ad;
  color: #ffffff;
  border: none;
  padding: 16px 60px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 6px 20px rgba(25, 178, 173, 0.3);
}

.user-notice-btn:hover {
  background: linear-gradient(135deg, #13bfba 0%, #0fa8a3 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(25, 178, 173, 0.4);
}

.user-notice-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(25, 178, 173, 0.3);
}

/* 知情同意书弹窗样式 */
.consent-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10001;
}

.consent-dialog {
  width: 95%;
  height: 100%;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  flex: 1;
  margin: 0px auto;
  border-radius: 8px;
  margin-top: 20px;
  max-height: calc(90vh - 40px);
}

.consent-header {
  padding: 16px 32px 12px;
  text-align: center;
  background: #ffffff;
  border-bottom: 1px solid #ebedf0;
  flex-shrink: 0;
}

.consent-title {
  font-size: 20px;
  font-weight: 600;
  color: #1f2226;
  margin: 0 0 12px 0;
}

.consent-meta {
  font-size: 14px;
  color: #7b8794;
  margin: 0;
  
  p {
    margin: 0;
    font-weight: 400;
  }
}

.consent-content {
  flex: 1;
  padding: 16px 32px;
  overflow-y: auto;
  background: #ffffff;
  min-height: 0;
  height: calc(90vh - 160px);
  
  /* 自定义滚动条样式 */
  &::-webkit-scrollbar {
    width: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
    
    &:hover {
      background: #a8a8a8;
    }
  }
}

.consent-text {
  font-size: 13px;
  line-height: 1.5;
  color: #1f2226;
}

.consent-intro {
  margin-bottom: 20px;
  text-indent: 2em;
}

.consent-section {
  margin-bottom: 16px;
  
  h3 {
    font-size: 15px;
    font-weight: 600;
    color: #1f2226;
    margin: 0 0 6px 0;
  }
  
  h4 {
    font-size: 14px;
    font-weight: 600;
    color: #1f2226;
    margin: 8px 0 4px 0;
  }
  
  p {
    margin: 0 0 4px 0;
    text-indent: 2em;
  }
}

.consent-footer {
  padding: 12px 32px 16px;
  text-align: center;
  background: #ffffff;
  border-top: 1px solid #ebedf0;
  flex-shrink: 0;
}

.consent-btn {
  background-color: #19b2ad;
  color: #ffffff;
  border: none;
  padding: 10px 32px;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
  
  &:hover {
    background-color: #13bfba;
  }
  
  &:active {
    background-color: #0fa8a3;
  }
}
.consent-dialog-container {
  width: 1036px;
  max-width: 95vw;
  height: 90vh;
  max-height: 90vh;
  background: #F3F3F3;
  // border-radius: 8px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

/* 公司信息样式 */
.company-info {
  text-align: right;
  margin-top: 20px;
  padding: 10px 0;
  
  p {
    margin: 0;
    font-size: 14px;
    color: #666;
    line-height: 2;
  }
}
</style>
